import CulbotEquipment from "./culbot-equipment.svg";

const AboutUs = {
  CulbotEquipment,
};

export default AboutUs;
